import { AddDevice, Devices as PatientDevices, EditDevice } from "patients-experience-client";
import { Devices as CommonDevices } from "common-util-experience-client";
import Form from "react-bootstrap/Form";
import { createPeripheralDevicesApi } from "../../../../api-helpers/CommonUtilsApiHelper";
import React, { useEffect, useState } from "react";
import Spinner from "../../../../components/Spinner";
import { createPatientApi } from "../../../../api-helpers/PatientApiHelper";
import { ToastConfig } from "../../../../components/Toaster";
import { Devices as Device} from "common-util-experience-client";

interface AddUpdateProps {
  selectedDevice: PatientDevices | undefined;
  patientId: string;
  setOffCanvasShow: (show: boolean) => void;
  onSubmit: (toasterConfig: ToastConfig) => void;
}

export const AddUpdateDevice: React.FC<AddUpdateProps> = (props: AddUpdateProps) => {
  const patientApi = createPatientApi();
  const peripheralDevicesApi = createPeripheralDevicesApi();
  const [peripheralDevices, setPeripheralDevices] = useState<Array<CommonDevices>>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [validated, setValidated] = useState(false);
  const [addForm, setAddForm] = useState<AddDevice>({} as AddDevice);
  const [updateForm, setUpdateForm] = useState<EditDevice>({
    serialNumber: props.selectedDevice?.serialNumber ?? ""
  });

  const handleDiscard = () => {
    props.setOffCanvasShow(false);
  };

  const getPeripheralDevices = async () => {
    setLoading(true);
    try {
      const response = await peripheralDevicesApi.peripheralDevicesControllerGetAll();
      setPeripheralDevices(response.data as unknown as CommonDevices[]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const formChnageHandler = (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const {name, value} = event.target;
    if(props.selectedDevice) {
      setUpdateForm({
        ...updateForm,
        [name]: value
      });
    } else {
      setAddForm({
        ...addForm,
        [name]: value
      });
    }
  }

  useEffect(() => {
    getPeripheralDevices();
  }, []);

  const submitHandler = async (event: any) => {
    event.preventDefault();
    setValidated(true);
    const form = event.currentTarget;
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }    
    setLoading(true);
    try {
      if (props.selectedDevice) {
            await patientApi.patientsControllerUpdatePatientDevice(updateForm, props.selectedDevice.id, props.patientId!);
      } else {
            await patientApi.patientsControllerAddDevice(addForm, props.patientId);
      }
      const toasterConfig = {
        type: "success",
        title: props.selectedDevice ? "Device updated successfully!" : "Device added successfully!",
        icon: "check_circle_outline",
      };
      props.onSubmit(toasterConfig as ToastConfig);
      setTimeout(() => {
        handleDiscard();
      }, 1000);
    } catch (error) {
      const toasterConfig = {
        type: "danger",
        title: props.selectedDevice ? "Error in updating device!" : "Error in adding device!",
        icon: "error_outline",
      };
      props.onSubmit(toasterConfig as ToastConfig);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Spinner />}
      <Form
        noValidate
        validated={validated}
        onSubmit={submitHandler}
        className="d-flex flex-column h-100">
        <div className="flex-fill">
          <div className="row g-2 mb-3">

            <div className="col-12">
              <div className="mb-3">
                <label
                  htmlFor="peripheralTypeId"
                  className="form-label fs-12 fw-semibold mb-1"
                >
                  Device
                </label>
                {props.selectedDevice !== undefined &&
                  <input value={props.selectedDevice?.deviceName + ' - ' + props.selectedDevice.modalName } className="form-control" disabled />
                }

                {props.selectedDevice === undefined &&
                  <select required
                    id="peripheralTypeId" value={addForm.peripheralTypeId}
                    className="form-select"
                    name="peripheralTypeId" onChange={formChnageHandler}
                  >
                    <option value="">Select Device</option>
                    {
                      peripheralDevices.length && peripheralDevices.map((peripheralDevice: CommonDevices, index: number) =>
                        <option key={index} value={peripheralDevice.id}>{peripheralDevice.name + ' - ' + peripheralDevice.modelNumber}</option>)
                    }
                  </select>
                }
              </div>
            </div>
            <div className="col-12">
              <div className="mb-3">
                <label
                  id="serialNumber"
                  htmlFor="serialNumber"
                  className="form-label fs-12 fw-semibold mb-1"
                >
                  Serial Number
                </label>
                <input required type="text" name="serialNumber" value={ props.selectedDevice ? updateForm.serialNumber : addForm.serialNumber } onChange={formChnageHandler} className="form-control" id="Model" placeholder="Enter Serial Number" />
              </div>
            </div>
          </div>
        </div>

        <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
          <div>
            <button
              className="btn btn-outline-secondary rounded-pill px-5 fs-13"
              type="reset"
              onClick={handleDiscard}
            >
              Discard
            </button>
          </div>
          <div>
            <button
              className="btn btn-secondary rounded-pill ps-4 pe-5 fs-13"
              type="submit"
            >
              {props.selectedDevice ? 'Update' : (
                <>
                {/* <span className="material-symbols-outlined fs-16 align-text-top">
                  add
                </span> */}
                  Add</>)}
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};
